
import Vue from "vue";
import {Component} from "vue-property-decorator";

@Component
export default class S404 extends Vue {
  name = "404"
}
